import React from "react";
import { useTranslation } from "react-i18next";
import { VelavuDevice } from "velavu-js-api";
import * as styles from "./device-environment.module.scss";
import { formatTemperatureString } from "../../../../helper/unit-helper";
import { useSignInContext } from "../../../sign-in-context/sign-in-context";

interface DeviceEnvironmentProps {
	device?: VelavuDevice;
}

export default function DeviceEnvironment(props: DeviceEnvironmentProps) {
	const { t } = useTranslation();

	const userContext = useSignInContext();
	const measurementSystem = userContext?.preferences?.measurementSystem;

	const temperature = props.device?.environment?.temperature_c;
	const humidity = props.device?.environment?.humidity;

	return (
		<div className={styles.container}>
			{temperature !== undefined && (
				<div className={styles.box}>
					<div className={styles.headers}>
						<span className={styles.ratingHeader}>
							{formatTemperatureString(
								temperature,
								measurementSystem,
							)}
						</span>
						<span className={styles.textHeader}>
							{t("dashboard.environment.temperature")}
						</span>
					</div>
				</div>
			)}
			{humidity !== undefined && (
				<div className={styles.box}>
					<div className={styles.headers}>
						<span className={styles.ratingHeader}>
							{`${Math.round(humidity)}%`}
						</span>
						<span className={styles.textHeader}>
							{t("dashboard.environment.humidity")}
						</span>
					</div>
				</div>
			)}
		</div>
	);
}
